export interface BreedAttributeProperties {
  level: number;
  health: number;
  hunger: number;
  maxLetters: number;
}

export const makeBaseStats = (): BreedAttributeProperties => ({
  level: 0,
  health: 0,
  hunger: 0,
  maxLetters: 0,
});
